import React from 'react';
import Footer from '../Footer/Footer';
import SeoContainerHeader from "../../Common/SeoContainerHeader";

const PageNotFound = (props) => {
  // TODO Redirect to HomePage
  const { src="", dest="", src_id="", dest_id="", date="", onUpdateSearch, showHeaderOnly, footer_links } = props

  return (
    <div className="seoContainer">
      <div className="desktopOnly">
        <SeoContainerHeader
          src={src}
          dest={dest}
          src_id={src_id}
          dest_id={dest_id}
          date={date}
          onUpdateSearch={onUpdateSearch}
          showHeaderOnly={showHeaderOnly}
        />

      </div>
      <div className="nfContentH">
        <div className="nfContentText">404</div>
        <div className="nfContentSubText">You've landed in No Man's Land! </div>
        <div className="nfContentSubText1">We're sorry. The page that you are looking for does not exist </div>
      </div>
      <Footer data={footer_links}></Footer>
    </div>
  )
}

export default PageNotFound;
